// extracted by mini-css-extract-plugin
export default {"root":"App_root__cjVGw"};